export { default } from './Manage';



// WEBPACK FOOTER //
// ./src/containers/Opportunities/ManageRefunds/index.js